import Footer from '../Footer';
import Navbar from '../Navbar';
import Topic9 from '../blog/topic9';


function App() {
  return (
    <>
      <Navbar />
      <Topic9 />
      <Footer />
    </>
  );
}

export default App;